import { motion } from "framer-motion";
import Reveal from "./Reveal";
import { specMove } from "./glass";

const GAINS = [
  "Better content",
  "Consistent publishing",
  "Less management",
  "More testing",
  "Faster iteration",
  "A team working behind the scenes",
];

const GONE = [
  "No more hunting for editors.",
  "No more chasing revisions.",
  "No more searching for thumbnail designers.",
  "No more managing five different freelancers.",
  "No more spending your evenings figuring out what to post.",
  "No more random views.",
  "No more ghosting.",
  "No more unexpected delays.",
  "No more inconsistent quality.",
];

const StrikeLine = ({ text, delay }) => (
  <Reveal delay={delay} y={16}>
    <div className="group flex items-center gap-5 border-t border-black/[0.08] py-6" data-testid={`dontdo-${text.slice(8, 20).replace(/\s+/g, "-").toLowerCase()}`}>
      <span className="relative font-display text-xl sm:text-2xl lg:text-3xl font-semibold tracking-[-0.02em] text-[#86868b]">
        {text}
        <motion.span
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: delay + 0.25, ease: [0.22, 1, 0.36, 1] }}
          className="absolute left-0 top-1/2 h-[2px] w-full origin-left bg-[#ef4444] shadow-[0_0_14px_rgba(239,68,68,0.9),0_0_34px_rgba(239,68,68,0.45)]"
          aria-hidden="true"
        />
      </span>
    </div>
  </Reveal>
);

export default function Outcomes() {
  return (
    <>
      <section className="bg-[#0a0a0a] py-28 sm:py-40" data-testid="outcomes-section">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <Reveal className="max-w-3xl">
            <span className="eyebrow text-[#6e6e73]">What you get back</span>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] leading-[1.06] text-white">
              You get your time back. And…
            </h2>
          </Reveal>
          <div className="mt-14 flex flex-wrap gap-4">
            {GAINS.map((g, i) => (
              <Reveal key={g} delay={i * 0.06} y={20}>
                <motion.span
                  onMouseMove={specMove}
                  whileHover={{ scale: 1.08, y: -4, rotate: i % 2 ? 1.5 : -1.5 }}
                  whileTap={{ scale: 0.93 }}
                  transition={{ type: "spring", stiffness: 260, damping: 16 }}
                  className="glass-dark glass-sheen glass-spec inline-flex cursor-default items-center rounded-full px-7 py-4 font-display text-base sm:text-lg font-semibold tracking-[-0.01em] text-white/85 transition-colors duration-300 hover:text-white"
                  data-testid={`gain-${g.slice(0, 14).replace(/\s+/g, "-").toLowerCase()}`}
                >
                  {g}
                </motion.span>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-28 sm:py-40" data-testid="dont-do-section">
        <div className="max-w-4xl mx-auto px-5 sm:px-8">
          <Reveal>
            <span className="eyebrow text-[#86868b]">Off your plate</span>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] leading-[1.06] text-[#1d1d1f]">
              What you don't have to do anymore
            </h2>
          </Reveal>
          <div className="mt-14">
            {GONE.map((g, i) => (
              <StrikeLine key={g} text={g} delay={i * 0.08} />
            ))}
            <div className="border-t border-black/[0.08]" />
          </div>
          <Reveal delay={0.3} className="mt-14">
            <p className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-[-0.02em] leading-snug text-[#1d1d1f]">
              I know. Life saver, right?
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
